module.exports = __webpack_public_path__ + "img/video-cn-1.e2c3273.jpg";